import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { RELATIVE_URL } from './crud-config';
import { IEvents } from 'src/app/domain/registration/models/IEvents';

@Injectable()
export class EventsService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public createEvent(eventData: Partial<IEvents>): Observable<{ id: string }> {
    return this.httpClient.post<{ id: string }>(`${API_PATH}${this.relativeUrl}`, eventData);
  }

  public getAllEvents(params: { getRelation: boolean; limit: number; page: number; filter: string }): Observable<any[]> {
    const query = `?getRelation=${params.getRelation ? 1 : 0}&limit=${params.limit}&page=${params.page}&filter=${params.filter}`;
    return this.httpClient.get<any[]>(`${API_PATH}${this.relativeUrl}${query}`);
  }

  public getEventById(id: string): Observable<IEvents> {
    return this.httpClient.get<IEvents>(`${API_PATH}event-forms/${id}?includeMeeting=true&expand=true`);
  }

  saveFormResponse(responseData: any): Observable<any> {
    return this.httpClient.post(`${API_PATH}/responses`, responseData);
  }

  public findById(id: string): Observable<IEvents> {
    return this.httpClient.get<IEvents>(`${API_PATH}event-forms/${id}`);
  }

  public findByName(name: string): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byName/${name}`
    );
  }

  public findByType(type: number): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byType/${type}`
    );
  }

  public findByFilter(filterForm: any, pagination: any): Observable<any[]> {
    const params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
      ...pagination,
    };

    return this.httpClient.post<any[]>(
      `${API_PATH}${this.relativeUrl}/filter`,
      { ...filterForm, ...params }
    );
  }

  findBySystem(id: any) {
    return this.httpClient.get<any[]>(
      `${API_PATH}${this.relativeUrl}/bySystem/${id}`
    );
  }

  findByTypeAndSystem(type: number, id: any) {
    return this.httpClient.get<any[]>(
      `${API_PATH}${this.relativeUrl}/byTypeAndSystem/${type}/${id}`
    );
  }

  public getMeetingFromEvent(eventId: string): Observable<any> {
    return this.httpClient.get(`${API_PATH}meetings/by-event/${eventId}`);
  }

  public getMeetingById(meetingId: string): Observable<any> {
    return this.httpClient.get(`${API_PATH}meetings/${meetingId}`);
  }
}
